<div class="filters mt-3">
  <!-- <h4 class="filters__title filters__title--first">Filtri</h4> -->
  <div class="filters__content" *ngIf="brand?.networkId === networks.WTG && (hasFiltersSelected || hasAccomodationSelected)">
    <div class="filters-type">
      <button class="btn btn--light-blue font-weight-normal c-card-booking__cta__button" (click)="resetFilters()">
        Reset filtri
      </button>
    </div>
  </div>
  <div class="filters__content" *ngIf="filters?.customHoliday.visible">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#length" aria-expanded="true" aria-controls="length">
          Speciali
        </button>
      </h6>
      <div id="holiday-custom" class="mt-3 collapse show">
        <form class="filters__check filters__check--specials" name="length">
          <div class="form-group-custom">
            <label class="form-check-custom">
              <input [(ngModel)]="filters?.customHoliday.value"
                     [value]="filters?.customHoliday.value"
                     name="custom-holiday"
                     (change)="applyFilter('customHoliday', undefined, filters?.customHoliday.value)"
                     type="checkbox"> Vacanza consigliata <i class="g-icon-light"></i>
              <span class="form-check-custom__check"></span>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="filters__content">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#top" aria-expanded="true" aria-controls="top">
          Tour Operator
        </button>
      </h6>
      <div id="top" class="mt-3 collapse show">
        <form class="filters__check" name="category">
          <div class="form-group-custom">
            <label *ngFor="let touroperator of filters?.touroperators" class="form-check-custom">
              <input [(ngModel)]="touroperator.checked"
                     [value]="touroperator.element.id"
                     [name]="'touroperators-'+touroperator.element.id"
                     (change)="applyFilter('touroperators', touroperator.element.id, touroperator.checked)"
                     type="checkbox">{{(touroperator.element.value | getDataFromMapping:'top' | async)?.Name}}
              <span class="form-check-custom__check"></span>
              <div class="form-check-custom__logo">
                <img [alt]="touroperator.element.value" [src]="touroperator.element.id | imageByCode:'top'" width="100%">
              </div>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="filters__content" *ngIf="filters?.departureDate.length > 1">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#departures" aria-expanded="true" aria-controls="departures">
          Data di partenza
          <span></span>
        </button>
      </h6>
      <div id="departures" class="mt-3 collapse show">
        <form class="filters__check" name="departures">
          <div class="form-group-custom">
            <label *ngFor="let departureDate of filters?.departureDate | orderBy: 'element.id'" class="form-check-custom">
              <input [(ngModel)]="departureDate.checked"
                     [value]="departureDate.element.id"
                     [name]="'departureDates-'+departureDate.element.id"
                     (change)="applyFilter('departureDate', departureDate.element.id, departureDate.checked)"
                     type="checkbox">{{departureDate.element.value | date: 'd MMM, YYYY'}}
              <span class="form-check-custom__check"></span>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="filters__content">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#accomodation" aria-expanded="true" aria-controls="accomodation">
          Struttura
        </button>
      </h6>
      <div id="accomodation" class="mt-3 collapse show">
        <form class="filters__check" name="price">
          <div class="form-group-custom filters__input">
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent input-group-custom--icon-append input-group-custom--icon-append--transparent">
              <div class="icon-group-custom__prepend icon-group-custom__prepend--transparent">
                <span id="basic-addon3" class="input-group-custom__icon input-group-custom__icon--transparent">
                  <i class="icon-search"></i>
                </span>
              </div>
              <input class="form-control-custom" id="accomodationInput" placeholder="Nome della struttura..."
                     name="accomodationInput"
                     [(ngModel)]="filteredAccomodation"
                     [resultFormatter]="accomodationFormatter"
                     [inputFormatter]="accomodationFormatter"
                     [editable]='false'
                     (selectItem)="accomodationChangeCB($event)"
                     [ngbTypeahead]="accomodationSearch">
<!--              <input class="form-control-custom" id="accomodationInput" placeholder="Nome della struttura...">-->
              <div class="icon-group-custom__append icon-group-custom__append--transparent close-element" *ngIf="filteredAccomodation" [ngClass]="{'disabled': !filteredAccomodation}" (click)="accomodationClearCB()">
                <span id="basic-addon4" class="input-group-custom__icon input-group-custom__icon--transparent">
                  <i class="g-icon-close"></i>
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="filters__content" *ngIf="filters.price.min!==filters.price.max">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#price" aria-expanded="true" aria-controls="price">
          Prezzo
        </button>
      </h6>
      <div id="price" class="mt-3 collapse show">
        <form class="filters__check" name="price">
          <div class="form-group-custom">
                <ngx-slider
                  [options]="priceSliderOptions"
                  [manualRefresh]="sliderRefresh"
                  (userChangeEnd)="sliderChangeCB($event)"
                  [(value)]="selectedMin"
                  [(highValue)]="selectedMax">
                </ngx-slider>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="filters__content" *ngIf="filters?.nights.length > 1">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#length" aria-expanded="true" aria-controls="length">
          Notti
        </button>
      </h6>
      <div id="length" class="mt-3 collapse show">
        <form class="filters__check" name="length">
          <div class="form-group-custom">
            <label *ngFor="let night of filters?.nights | orderBy: 'element.id'" class="form-check-custom">
              <input [(ngModel)]="night.checked"
                     [value]="night.element.id"
                     [name]="'nights-'+night.element.id"
                     (change)="applyFilter('nights', night.element.id, night.checked)"
                     type="checkbox">{{night.element.value}} notti
              <span class="form-check-custom__check"></span>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="filters__content">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#category" aria-expanded="true" aria-controls="category">
          Categoria
        </button>
      </h6>
      <div id="category" class="mt-3 collapse show">
        <form class="filters__check" name="category">
          <div class="form-group-custom">
            <label *ngFor="let category of filters?.categories | orderBy: 'element.value.value'" class="form-check-custom">
              <input [(ngModel)]="category.checked"
                     [value]="category.element.id"
                     [name]="'categorys-'+category.element.id"
                     (change)="applyFilter('categories', category.element.id, category.checked)"
                     type="checkbox">
              <span *ngIf="!category.element.value.value">{{category.element.value.label}}</span>
              <span class="c-card-stars" *ngIf="category.element.value.value">
                <i class="star-coloured" *ngFor="let star of numberToArray(category.element.value.value)"
                   [ngClass]="category.element.value.icon">
                </i>
                <i class="star-coloured" *ngIf="category.element.value.extra">
                  {{category.element.value.extra}}
                </i>
              </span>
              <span class="form-check-custom__check"></span>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="filters__content">
    <div class="filters-type">
      <h6 class="filters-type__title">
        <button class="btn btn--accordion btn--accordion--not-collapsible" data-toggle="collapse" data-target="#treatment" aria-expanded="true" aria-controls="treatment">
          Trattamento
        </button>
      </h6>
      <div id="treatment" class="mt-3 collapse show">
        <form class="filters__check" name="treatment">
          <div class="form-group-custom">
            <label *ngFor="let basis of filters?.basis" class="form-check-custom">
              <input [(ngModel)]="basis.checked"
                     [value]="basis.element.id"
                     [name]="'basiss-'+basis.element.id"
                     (change)="applyFilter('basis', basis.element.id, basis.checked)"
                     type="checkbox">{{basis.element.value || (basis.element.id | getDataFromMapping:'basis' | async)?.Name}}
              <span class="form-check-custom__check"></span>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>
